export default __webpack_public_path__ + "static/media/ic_vehicles.f0ad129a.svg";